import Support from './containers/SupportContainer'

export default {
  path: '/support',
  component: Support
}



// WEBPACK FOOTER //
// ./src/routes/support/index.js